import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ZefForm, ZefFormsManagerService } from '@zerops/zef/forms';
import { AppState } from '@zerops/zerops/app';
import { FormControlState, FormGroupState, FormState, setErrors, validate } from 'ngrx-forms';
import { FEATURE_NAME } from './automatic-top-up-config-dialog.constant';
import { greaterThanOrEqualTo, required } from 'ngrx-forms/validation';

export interface AutomaticTopUpConfigDialogFormValue {
  enabled: boolean;
  threshold: number;
  amount: number;
  calendarMonthlyLimit: number;
}

export type AutomaticTopUpConfigDialogFormState = FormState<AutomaticTopUpConfigDialogFormValue>;

const whenEnabled = (validator: (s: FormControlState<number>) => FormControlState<number>) =>
  (s: FormControlState<number>, ps: FormGroupState<AutomaticTopUpConfigDialogFormValue>) => {
    if (ps?.controls?.enabled?.value) {
      return validator(s);
    }
    return setErrors(s, {});
  };

@Injectable({ providedIn: 'root' })
export class AutomaticTopUpConfigDialogForm extends ZefForm<AutomaticTopUpConfigDialogFormValue> {
  constructor(
    public store: Store<AppState>,
    public formsManager: ZefFormsManagerService
  ) {
    super(
      store,
      formsManager,
      FEATURE_NAME,
      {
        enabled: false,
        threshold: undefined,
        amount: undefined,
        calendarMonthlyLimit: undefined
      },
      {
        threshold: whenEnabled(validate<number>(required, greaterThanOrEqualTo(5))),
        amount: whenEnabled(validate<number>(required, greaterThanOrEqualTo(10))),
        calendarMonthlyLimit: (s, ps) => {
          if (!ps?.controls?.enabled?.value) {
            return setErrors(s, {});
          }
          // Must be at least the top-up amount.
          const amount = ps?.controls?.amount?.value ?? 0;
          return validate<number>(required, greaterThanOrEqualTo(amount))(s);
        }
      }
    );
  }
}
